import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Sheet, SheetContent, SheetHeader, SheetTitle } from '@/components/ui/sheet';
import { Button } from '@/components/ui/button';
import { Minus, Plus, Trash2, ShoppingCart } from 'lucide-react';
import { useShopCart } from '@/context/ShopCartContext';
import { useShopOrg } from '@/context/ShopOrgContext';

const CartDrawer = () => {
  const navigate = useNavigate();
  const { slug } = useShopOrg();
  const { cart, cartOpen, setCartOpen, changeQuantity, removeFromCart, cartTotal } = useShopCart();

  const goToCheckout = () => {
    setCartOpen(false);
    navigate(`/${slug}/shop/checkout`);
  };

  return (
    <Sheet open={cartOpen} onOpenChange={setCartOpen}>
      <SheetContent className="flex flex-col">
        <SheetHeader>
          <SheetTitle>Winkelwagen</SheetTitle>
        </SheetHeader>
        {cart.length === 0 ? (
          <div className="flex-1 flex flex-col items-center justify-center text-slate-500 gap-2">
            <ShoppingCart className="w-10 h-10 text-slate-300" />
            <p className="text-sm">Je winkelwagen is leeg.</p>
          </div>
        ) : (
          <>
            <div className="flex-1 overflow-y-auto space-y-4 py-2">
              {cart.map((line) => (
                <div key={line.product.id} className="flex items-center gap-3">
                  <div className="w-14 h-14 rounded-lg bg-slate-50 flex items-center justify-center overflow-hidden shrink-0">
                    {line.product.image_url ? (
                      <img src={line.product.image_url} alt={line.product.title} className="max-w-full max-h-full object-contain" />
                    ) : (
                      <ShoppingCart className="w-5 h-5 text-slate-300" />
                    )}
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-medium text-slate-900 line-clamp-1">{line.product.title}</p>
                    <p className="text-xs text-slate-500">
                      € {((line.product.sale_price ?? line.product.price) * line.quantity).toFixed(2)}
                    </p>
                  </div>
                  <div className="flex items-center gap-1">
                    <Button variant="outline" size="sm" className="rounded-lg h-7 w-7 p-0" onClick={() => changeQuantity(line.product.id, -1)}>
                      <Minus className="w-3 h-3" />
                    </Button>
                    <span className="w-6 text-center text-sm">{line.quantity}</span>
                    <Button variant="outline" size="sm" className="rounded-lg h-7 w-7 p-0" onClick={() => changeQuantity(line.product.id, 1)}>
                      <Plus className="w-3 h-3" />
                    </Button>
                  </div>
                  <Button variant="ghost" size="sm" onClick={() => removeFromCart(line.product.id)} className="text-red-600">
                    <Trash2 className="w-4 h-4" />
                  </Button>
                </div>
              ))}
            </div>
            <div className="border-t border-slate-100 pt-4 space-y-3">
              <div className="flex items-center justify-between">
                <span className="text-sm text-slate-500">Totaal (incl. btw)</span>
                <span className="text-lg font-semibold text-slate-900">€ {cartTotal.toFixed(2)}</span>
              </div>
              <Button className="w-full rounded-xl bg-teal-600 hover:bg-teal-700" onClick={goToCheckout}>
                Afrekenen
              </Button>
            </div>
          </>
        )}
      </SheetContent>
    </Sheet>
  );
};

export default CartDrawer;
